export const MentorshipAvailabilityPayload = (JsonData) => {
  // Log incoming data for debugging
  console.log("MentorshipAvailabilityPayload - JsonData:", JsonData);
  
  const details = JsonData.data.reduce((acc, { name, value }) => {
    acc[name] = value;
    return acc;
  }, {});

  // Log extracted details for debugging
  console.log("MentorshipAvailabilityPayload - details:", details);

  // Helper function to ensure boolean fields have proper True/False values
  const getBooleanValue = (value) => {
    // Handle various input formats
    if (value === "True" || value === true || value === "true") return "True";
    if (value === "False" || value === false || value === "false") return "False";
    // If empty/undefined/null, this shouldn't happen for required fields, but handle it
    if (value === "" || value === null || value === undefined) {
      console.warn("Boolean field has empty value, defaulting to False");
      return "False";
    }
    // Fallback
    return String(value);
  };

  const payload = {
    id: JsonData.id,
    recordtype: JsonData.recordtype,
    data: [
      {
        name: "ctpt_optedintosaiceconnect",
        value: details["ctpt_optedintosaiceconnect"] || "",
        type: "string",
      },
      {
        name: "ctpt_availabledaytime",
        value: getBooleanValue(details["ctpt_availabledaytime"]),
        type: "boolean",
      },
      {
        name: "ctpt_availableevenings",
        value: getBooleanValue(details["ctpt_availableevenings"]),
        type: "boolean",
      },
      {
        name: "ctpt_availableonweekdays",
        value: getBooleanValue(details["ctpt_availableonweekdays"]),
        type: "boolean",
      },
      {
        name: "ctpt_availableonweekends",
        value: getBooleanValue(details["ctpt_availableonweekends"]),
        type: "boolean",
      },
      {
        name: "ctpt_availabilitynotes",
        value: details["ctpt_availabilitynotes"] || "",
        type: "string",
      },
      {
        name: "ctpt_connectmentee",
        value: getBooleanValue(details["ctpt_connectmentee"]),
        type: "boolean"
      }
    ],
  };
  
  // Log final payload for debugging
  console.log("MentorshipAvailabilityPayload - final payload:", payload);
  
  return payload;
};

